import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import DatePickers from './DatePicker';
import LongText from './LongText';
import Phone from './Phone';

const PediatricDischargeForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ترخیص اطفال'} subHeader={'لطفا فرم زیر را برای ترخیص بیمار اطفال تکمیل کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی بیمار'} />
                <DatePickers header={'تاریخ تولد'}/>
                <DatePickers header={'تاریخ پذیرش'}/>
                <DatePickers header={'تاریخ ترخیص'}/>
                <FullName header={'نام پزشک معالج'} />
                <LongText header={'تشخیص'}/>
                <LongText header={'درمان ارائه شده'}/>
                <LongText header={'دستورالعمل‌های ترخیص'}/>
                <FullName header={'نام والدین/سرپرست'}/>
                <Phone header={'شماره تماس والدین/سرپرست'}/>
            </Grid>
        </Grid>
    )
}

export default PediatricDischargeForm
